import { Colors } from '@zapier/design-system';
import { css } from '@emotion/core';

export default {
  comment: css`
    word-wrap: break-word;
  `,
  header: (isZapierStaff: boolean) => [
    css`
      background-color: ${Colors.GrayWarm2};
      padding: 15px;
      border-top-right-radius: 4px;
      border-top-left-radius: 4px;
    `,
    isZapierStaff &&
      css`
        background-color: ${Colors.GrayWarm7};
        color: ${Colors.PrimeWhite};
      `,
  ],
  body: css`
    padding: 15px;
  `,
  footer: css`
    padding: 10px 15px;
    border-top: 1px solid ${Colors.GrayWarm3};
    display: flex;
    align-items: center;
  `,
};
